<template>
  <panel v-if="clients" width="300" title="Clients">
    <div class="list">
      <div v-for="(c, index) in clients" :key="index" @click="selectClient(index)"
           :class="'client ' + ((client && client.id === c.id) ? 'active' : '')">
        <div class="initials">{{ initials(c.company) }}</div>
        <div class="company">{{ c.company }}</div>
      </div>
    </div>
  </panel>
</template>

<script>
import Panel from "@/components/layout/Panel"
export default {
  name: 'ClientList',
  props: ['clients', 'value'],
  components: {
    Panel
  },
  data() {
    return {

    }
  },
  computed: {
    client: {
      get() {
        return this.value;
      },
      set(client) {
        this.$emit("input", client);
      }
    }
  },
  methods: {
    selectClient(index) {
      this.client = this.clients[index];
      this.$router.push({name: 'clients-view', params: {id: this.client.id} })
    },
    initials(company) {
      if (company){
        return company.match(/\b(\w)/g).join('');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
.list {
  height: calc(100vh - 180px);
  overflow-y: scroll;
  overflow-x: hidden;
  .client {
    max-width: 260px;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 10px;
    margin-top: 6px;
    border-radius: 4px;
    cursor: pointer;
    .initials {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border-radius: 50%;
      background-color: $default;
      font-size: 10px;
      font-weight: 700;
      margin-right: 10px;
    }
    .company {
      font-size: 14px;
      font-weight: 500;
    }
    &.active {
      background: rgba($default, 0.4);
      border: 1px solid rgba($default, 0.5);
    }
    &:hover {

    }
  }
  &::-webkit-scrollbar {
    width: 12px;
  }
  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    background: #ccc;
  }
  &::-webkit-scrollbar-track-piece {
    background: white;
  }
}
</style>